import {Component, Watch, Mixins} from 'vue-property-decorator'
import {debounce} from 'lodash'
import {$, MixinQueryRouter, PageCollection, Resource} from 'simpli-web-sdk'
import {AppConfig} from '@/config/app.config'
import {MixinRouteMatch} from '@/components/mixins/MixinRouteMatch'

@Component
export class MixinFilter extends Mixins(MixinQueryRouter, MixinRouteMatch) {
  debounce = debounce(async () => await this.populate(), AppConfig.debounceWaitTime)

  autoFiltrate = false
  filter?: any
  collection?: PageCollection<Resource>
  populateOnMount = true
  queriesToHide: string[] = []

  @Watch('filter', {deep: true})
  async filterEvent() {
    if (this.collection) {
      this.collection.currentPage = 0
    }
    if (this.autoFiltrate) {
      await this.filtrate()
    }
  }

  async filtrate() {
    $.await.init('searchQuery')
    try {
      this.updateRouteFromObject(this.filter, this.queriesToHide)

      if (this.autoFiltrate) {
        await this.debounce()
      } else {
        await this.populate()
      }
      $.await.done('searchQuery')
    } catch {
      $.await.done('searchQuery')
    }
  }

  async populate() {
    await this.query()
  }

  created() {
    this.updateObjectFromRoute(this.filter)
  }

  async mounted() {
    await this.$nextTick()
    this.debounce.cancel()
    if (this.populateOnMount) await this.debounce()
  }
}
